// need the prefix to prevent circular import.
export { randomBytes } from 'node:crypto';
